import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/ChatOnboarding/Steps/DiagnosisUnlockFlow/LoadingStep/diagnosisUnlockFourStep.contract";
const I18n = I18nUtil.createScoped(Translations);
/**
 * Loading 步骤 progress 配置 — Figma `90772:39818` 默认四步。
 */

/** 每步 active 态最短展示时长（ms），全部播完自动进入 Step2 */
export const DIAGNOSIS_UNLOCK_STEP_PROGRESS_ACTIVE_MS = 900;

/** @deprecated 使用 {@link DIAGNOSIS_UNLOCK_STEP_PROGRESS_ACTIVE_MS} */
export const DIAGNOSIS_UNLOCK_FOUR_STEP_ACTIVE_MS =
  DIAGNOSIS_UNLOCK_STEP_PROGRESS_ACTIVE_MS;

/**
 * `showStepProgress: false` 时 — 仅标题 + 涟漪，最短展示后自动进 Step2。
 */
export const DIAGNOSIS_UNLOCK_SIMPLE_LOADING_MS = 3_000;

export type DiagnosisUnlockStepProgressStatus =
  | "completed"
  | "active"
  | "pending";

/** Figma `90772:39818` 默认四步文案 */
export function getDefaultStepProgressLabels(): readonly string[] {
  return [
    I18n.t("Connected to Schwab"),
    I18n.t("Read your positions"),
    I18n.t("Checking sector concentration"),
    I18n.t("Drafting your guardrail plan"),
  ];
}

/**
 * 解析 `showStepProgress` 配置。
 *
 * - `false` → 不展示步骤列表
 * - `undefined` → 默认四步文案
 * - `string[]` → 自定义步骤（长度任意 ≥1）
 */
export function resolveStepProgressLabels(
  config: false | readonly string[] | undefined,
): readonly string[] | null {
  if (config === false) {
    return null;
  }
  if (config === undefined) {
    return getDefaultStepProgressLabels();
  }
  if (config.length === 0) {
    return null;
  }
  return config;
}

/** 根据当前 active 索引计算各步状态 */
export function getStepProgressStatuses(
  labels: readonly string[],
  activeIndex: number,
): DiagnosisUnlockStepProgressStatus[] {
  return labels.map((_, index) => {
    if (index < activeIndex) {
      return "completed";
    }
    if (index === activeIndex) {
      return "active";
    }
    return "pending";
  });
}

/** 全部 completed 时 activeIndex === labels.length */
export function isStepProgressSequenceComplete(
  labels: readonly string[],
  activeIndex: number,
): boolean {
  return activeIndex >= labels.length;
}

/** @deprecated 使用 {@link getStepProgressStatuses} */
export function getFourStepStatuses(
  activeIndex: number,
): DiagnosisUnlockStepProgressStatus[] {
  return getStepProgressStatuses(getDefaultStepProgressLabels(), activeIndex);
}

/** @deprecated 使用 {@link isStepProgressSequenceComplete} */
export function isFourStepSequenceComplete(activeIndex: number): boolean {
  return isStepProgressSequenceComplete(
    getDefaultStepProgressLabels(),
    activeIndex,
  );
}
